import React, { useRef, useEffect, useState } from "react";
import "./analyze.css";

function Analyze() {
  const audioContext = useRef(null);

  // 内部状態
  const [spect, setSpect] = useState(new Uint8Array());
  const freqIndex = useRef([]);

  //音階名
  const hzName = [
    "A",
    "A#",
    "B",
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
  ];

  // 見るべき周波数
  let hzs = [[27.5]];
  // Aだけ先に入れる誤差対策
  let octs = 6;
  for (let i = 0; i < octs - 1; i++) {
    hzs.push([hzs[i] * 2]);
  }
  let root12 = Math.pow(2, 1 / 12);
  for (let i = 0; i < octs; i++) {
    for (let j = 1; j < 12; j++) {
      hzs[i].push(Math.round(hzs[i][j - 1] * root12 * 100) / 100);
    }
  }
  hzs = hzs.flat();

  // 初期化
  useEffect(() => {
    audioContext.current = new AudioContext({ sampleRate: 4000 });
  }, []);

  const connectMic = async () => {
    // 中止状態の解除
    if (audioContext.current.state === "suspended")
      audioContext.current.resume();

    //マイク取得・アナライザー接続
    console.log(window.navigator)
    console.log(window.navigator.mediaDevices)
    const stream = await window.navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then()
      .catch((e) => {
        console.error(e);
      });
    const input = audioContext.current.createMediaStreamSource(stream);
    const analyser = audioContext.current.createAnalyser();
    input.connect(analyser);

    //アナライザー設定
    analyser.fftSize = 2048;
    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);
    setInterval(() => {
      analyser.getByteFrequencyData(dataArray);
      setSpect(dataArray.slice(0));
    }, 33);
    let hz = 0;
    for (let i = 0; i < bufferLength; i++) {
      freqIndex.current.push(hz);
      hz += audioContext.current.sampleRate / 2 / (bufferLength - 1);
    }
    console.log(freqIndex.current);
  };
  const array2list = (array) => {
    return Array.from(array).map((elm, index) => {
      const tmp = (
        <span
          style={{ backgroundColor: `rgb(${elm},60,60)` }}
          className={"spect-span"}
          key={index}
        >
          e
        </span>
      );
      return tmp;
    });
  };
  const calcFreqPow = (data, freq) => {
    if (freqIndex.current.length <= 0) return <div>mu</div>;
    let over = freqIndex.current.find((elm) => elm >= freq);
    let cur = freqIndex.current.findIndex((elm) => elm === over);
    return (data[cur] + data[cur - 1]) / 2;
  };

  const hzsList = (spect) => {
    return hzs.map((elm, index) => {
      let pow = calcFreqPow(spect, elm);
      pow = Math.round(pow / 20) * 20;
      return (
        <span
          className={"w60"}
          key={index}
          style={{ backgroundColor: `rgb(${pow},${pow},150)` }}
        >
          {elm} | {pow}
        </span>
      );
    });
  };

  return (
    <div>
      <h2>poe</h2>
      <button className={"p10 m10"} onClick={connectMic}>
        マイク接続
      </button>
      <p>{array2list(spect)}</p>
      <div className={"w720"}>{hzsList(spect)}</div>
      <div>
        {hzName.map((elm, index) => {
          return (
            <span className={"w60 text-center"} key={index}>
              {elm}
            </span>
          );
        })}
      </div>
    </div>
  );
}

export default Analyze;
